module.exports = __webpack_public_path__ + "static/media/logo we dress.29aa6e4e.png";